import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * Renders a patient's name as a link to their profile (`/patients/:id`).
 * `stopPropagation` keeps it safe inside rows that have their own onClick
 * navigation. Falls back to plain text when no id is available. Do NOT nest
 * this inside another <a>/<Link> (invalid HTML) — render plain text there.
 */
export function PatientLink({
  id,
  name,
  className,
}: {
  id: string | null | undefined;
  name: string;
  className?: string;
}) {
  if (!id) return <span className={className}>{name}</span>;
  return (
    <Link
      to={`/patients/${id}`}
      onClick={(e) => e.stopPropagation()}
      className={cn("hover:text-primary hover:underline", className)}
    >
      {name}
    </Link>
  );
}
